import { render, staticRenderFns } from "./GolstatsData.vue?vue&type=template&id=4381245c&scoped=true&"
import script from "./GolstatsData.vue?vue&type=script&lang=js&"
export * from "./GolstatsData.vue?vue&type=script&lang=js&"
import style0 from "./GolstatsData.vue?vue&type=style&index=0&id=4381245c&prod&lang=css&"
import style1 from "./GolstatsData.vue?vue&type=style&index=1&id=4381245c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381245c",
  null
  
)

export default component.exports